import {Match} from "@/sources/kicker-amateur/types";

export function getResult(result?: number) {
  return result !== undefined ? result : "-";
}

export function getMatchTitle(match: Match) {
  return `${match.ATeam?.ShortName} - ${match.BTeam?.ShortName}`;
}
